module.exports = __webpack_public_path__ + "static/media/liveFeedBrowser.1cd9d474.png";